import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../../Styles/PageStyles";
import Images from "../../../Images";
import tw from "tailwind-styled-components";
import moment from "moment";
import { PaginationLimit } from "../../../Config";
import { capitalizeFirstLetter, getDueTypeLabel, getModeName, handleCopy, truncateText } from "../../../helpers";
import { IoCopySharp } from "react-icons/io5";
import { MdOutlineChevronRight } from "react-icons/md";

const CollectionTable = ({
    apiData,
    setSelectedData,
    setViewDetail,
}) => {

    const storageKey = `collection_page`;
    const [data, setData] = useState([
        {
            deviceName: "",
            extractionTime: "",
            processingTime: "",
            drops: "",
            action: "",
        },
    ]);

    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [openActionMenu, setOpenActionMenu] = useState(null);

    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };

    const storageValue = sessionStorage.getItem(storageKey);
    const savedPage = storageValue !== null ? Number(storageValue) : 0;
    const [currentPage, setCurrentPage] = useState(savedPage);
    useEffect(() => {
        setCurrentPage(savedPage);
    }, [savedPage]);
    const viewDetails = (item) => {
        setSelectedData(item);
        setViewDetail(true);
    };
    const ActionBtns = (item) => {
        return (
            <div className="flex gap-4 ">
                <button
                    onClick={() => viewDetails(item)}
                    className={`cursor-pointer text-sm px-4 py-1 rounded-lg ${' text-gray-600'} flex items-center gap-1`}
                >
                    <MdOutlineChevronRight className="text-gray-300" size={24} />
                </button>
            </div>
        );
    };
    useEffect(() => {
        if (apiData) {
            const tempData = apiData.map((item) => ({
                tenant: getTenant(item),
                amount: getAmount(item),
                mode: getMode(item),
                date: getDate(item),
                property: getProperty(item),
                transactionFor: getDesc(item),
                action: ActionBtns(item),
                originalItem: item
            }));
            setData(tempData);
        }
    }, [apiData, openActionMenu]);

    const getDesc = (item) => {
        // let transactionFor = getDueTypeLabel(item.type);
        const transactionFor = item.type === 1 ? "Rent"
            : item.type === 43 ? "Security"
                : item.type === 5 ? "Maintenance"
                    : "Other";
        return (
            <div className="flex flex-col gap-1">
                <span
                    className="text-gray-600 text-sm"
                >
                    {transactionFor}
                </span>
            </div>
        );
    };

    const getAmount = (item) => {
        return (
            <Amount className='bg-blue-100 text-gray-600'>
                ₹{item.amount?.toLocaleString()}
            </Amount>
        );
    };

    const getTenant = (item) => {
        const name = capitalizeFirstLetter(item?.paidByName || "N/A");

        return (
            <UserImageWrapper>
                <div className="flex-row flex">
                    <UserImage src={item.profilePicture ? item.profilePicture : Images.Avatar} alt={`Avatar for ${name}`} />
                </div>
                <div className="flex flex-col gap-1">
                    <span className="text-gray-600 text-sm">
                        {truncateText(name, 25)}
                    </span>
                    <div className="flex gap-1">
                        <span className="text-gray-400 text-xs">#{item.paidByMobile}</span>
                        <button onClick={(e) => {
                            e.stopPropagation();
                            handleCopy(item.paidByMobile);
                        }}>
                            <IoCopySharp size={10} className="text-gray-400" />
                        </button>
                    </div>
                </div>
            </UserImageWrapper>
        );
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const getMode = (item) => {
        return (
            <div className='flex flex-col gap-1'>
                <span className="text-gray-600 text-sm">
                    {getModeName(item.paymentMethod)}
                </span>
            </div>
        );
    };

    const getDate = (item) => {

        return (
            <div className="flex flex-col text-sm text-gray-600">
                <span> {moment(item.paidDate).format("DD, MMM YY")}
                </span>

            </div>
        );
    };

    const getProperty = (item) => {
        return (
            <div className="flex flex-col text-sm text-gray-600">
                <span >
                    {item.propName || "--"}
                </span>
            </div>
        );
    };


    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {
            return [
                {
                    Header: "Name",
                    accessor: "tenant",
                },
                {
                    Header: "Amount",
                    accessor: "amount",
                },
            ];
        }
        return [
            {
                Header: "Name",
                accessor: "tenant",
            },
            {
                Header: "Property",
                accessor: "property",
            },
            {
                Header: "Amount",
                accessor: "amount",
            },
            {
                Header: "For",
                accessor: "transactionFor",
            },
            // {
            //     Header: "Mode",
            //     accessor: "mode",
            // },

            {
                Header: "Paid Date",
                accessor: "date",
            },
            {
                Header: "",
                accessor: "action",
            },

        ];
    }, [isMobileView]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex },
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );

    useEffect(() => {
        sessionStorage.setItem(storageKey, pageIndex);
    }, [pageIndex, storageKey]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);

                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}
                                >
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-3 p-2">
                                                <li>
                                                    <strong className="block text-gray-500 text-sm">Mode</strong>
                                                    {data[rowIndex].mode}
                                                </li>
                                                <li>
                                                    <strong className="block text-gray-500 text-sm">Property</strong>
                                                    {data[rowIndex].property}
                                                </li>
                                                <li>
                                                    <strong className="block text-gray-500 text-sm">Paid Date</strong>
                                                    {data[rowIndex].date}
                                                </li>
                                                <li>
                                                    <strong>Action</strong>{" "}
                                                    {data[rowIndex].action}
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
        </>
    );
};

const UserImageWrapper = tw.div` flex items-center gap-2`;
const UserImage = tw.img`w-9 h-9 rounded-full `;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Amount = tw.div`text-sm px-3 py-1 rounded-md inline-flex items-center`

export default CollectionTable;